import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WalletProvider } from "@/providers/wallet-provider";
import { AccountSheetProvider } from "@/providers/account-sheet";
import { TransactionSheetProvider } from "@/providers/transaction-sheet-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import Layout from "@/components/layout";
import * as Pages from "@/pages/index";
import { Toaster } from "./components/ui/toaster";
import "./preload-token-colors.ts";
import { dsDisabled } from "./config";
import { GreenScreen } from "./pages/green-screen.tsx";
import { AprScreen } from "./pages/aprscreen.tsx";
import { queryClient } from "./lib/query-client.ts";
import { HelmetProvider } from "react-helmet-async";
import { TimeframeTabProvider } from "./providers/timeframe-tab-context.tsx";
import { persister } from "./lib/query-persister.ts";

function App() {
  return (
    <HelmetProvider>
      <WalletProvider>
        <PersistQueryClientProvider
          persistOptions={{ persister }}
          client={queryClient}
        >
          <AccountSheetProvider>
            <TimeframeTabProvider>
              <TransactionSheetProvider>
                <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
                  <BrowserRouter>
                    <Toaster />
                    <Routes>
                      <Route
                        path="/greenscreen/:id"
                        element={<GreenScreen />}
                      />
                      <Route path="/aprscreen/:ids" element={<AprScreen />} />
                      <Route path="/" element={<Layout />}>
                        <Route path="/" element={<Pages.Home />} />
                        {!dsDisabled ? (
                          <>
                            <Route
                              path="/analytics"
                              element={<Pages.Analytics />}
                            />
                            <Route
                              path="/analytics/:token"
                              element={<Pages.Analytics />}
                            />
                            <Route path="/asset" element={<Pages.Asset />} />
                            <Route
                              path="/asset/:id"
                              element={<Pages.Asset />}
                            />
                            <Route
                              path="/account/:address"
                              element={<Pages.Account />}
                            />
                            <Route
                              path="/dualSTAKE"
                              element={<Pages.DualStake />}
                            />
                            <Route
                              path="/dualSTAKE/request"
                              element={<Pages.DualStake />}
                            />
                            <Route
                              path="/dualSTAKE/sunset"
                              element={<Pages.DualStakeSunset />}
                            />
                            <Route
                              path="/dualSTAKE/:token"
                              element={<Pages.DualStake />}
                            />
                          </>
                        ) : null}
                        <Route path="*" element={<Pages.NotFound />} />
                        <Route path="/bench" element={<Pages.Bench />} />
                        <Route
                          path="/bench/create"
                          element={<Pages.BenchCreate />}
                        />
                        <Route
                          path="/bench/:id"
                          element={<Pages.BenchSingle />}
                        />
                        <Route
                          path="/bench/:id/manage"
                          element={<Pages.BenchManage />}
                        />
                      </Route>
                    </Routes>
                  </BrowserRouter>
                </ThemeProvider>
              </TransactionSheetProvider>
            </TimeframeTabProvider>
          </AccountSheetProvider>
        </PersistQueryClientProvider>
      </WalletProvider>
    </HelmetProvider>
  );
}

export default App;
